<template>
  <div class="contact-item">
    <div class="contact-info">
      <div class="contact-name">
        <!-- El email pertenece al comercial asignado y puede no existir si no
             hay comercial asociado a la compañía activa. -->
        <p>
          <strong>{{ commercial.name }}</strong>
        </p>
        <!-- Igual que "¿Podemos ayudarte?", no se declara mailto como destino
             de navegación: el manejador abre el cliente de correo local. -->
        <f7-link
          v-if="commercial.email"
          class="contact-email"
          :href="undefined"
          @click.prevent.stop="openEmail"
        >
          {{ commercial.email }}
        </f7-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommercialData',
  props: {
    commercial: { type: Object, required: true },
  },
  methods: {
    openEmail() {
      // Framework7 puede interpretar un enlace mailto como una ruta interna;
      // se detiene ese comportamiento y se abre el cliente de correo local.
      if (this.commercial.email) {
        window.open(`mailto:${this.commercial.email}`, '_blank');
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/components/ClientArea/clientArea.scss';
</style>
